export default __webpack_public_path__ + "static/media/Ring of Flaming Fury.a2de6d8a.jpg";